<template>
	<sidenav :groups="groups" />
</template>

<script>
export default {
	name: "ConfigSidenav",
	data() {
		return {
			user: this.$route.meta.user,
			groups: {
				"User Management": [
					{
						name: "Pending Users",
						path: "/pending_users",
						permission: "page_config_users",
						icon: "fa-user-check",
					},
					{
						name: "Users",
						path: "/users",
						permission: "page_config_users",
						icon: "fa-user",
					},
					{
						name: "Roles",
						path: "/roles",
						permission: "page_config_current_tenant",
						icon: "fa-user-shield",
					},
					{
						name: "Teams",
						path: "/teams",
						permission: "page_config_teams",
						icon: "fa-hands-helping",
					},
				],
				Rostering: [
					{
						name: "Tenant",
						path: "/tenant",
						permission: "page_config_current_tenant",
						icon: "fa-building",
					},
					{
						name: "Districts",
						path: "/districts",
						permission: "page_config_districts",
						icon: "fa-graduation-cap",
					},
					{
						name: "Schools",
						path: "/schools",
						permission: "page_config_schools",
						icon: "fa-school",
					},
					{
						name: "Classes",
						path: "/admin/classes",
						permission: "page_config_classes",
						icon: "fa-grip-horizontal",
					},
					{
						name: "Courses",
						path: "/admin/courses",
						permission: "page_config_courses",
						icon: "fa fa-book-open",
					},
					{
						name: "Students",
						path: "/students",
						permission: "page_config_students",
						icon: "fa-users",
					},
					{
						name: "TaskBank Config",
						path: "/taskbank",
						permission: "page_config_students",
						icon: "fa-building",
					},
					{
						name: "Bank Comments",
						path: "/bank_comments",
						permission: "moderate_bank_comments",
						icon: "fa-building",
					},
				],

				"Setup/Configuration": [
					{
						name: "Content Areas",
						path: "/content_areas",
						permission: "page_config_content_areas",
						icon: "fa-chalkboard",
					},
					{
						name: "Pending Assmts",
						path: "/pendingassessments",
						permission: "page_approve_assessment",
						icon: "fa-clock",
					},
					{
						name: "My Assessments",
						path: "/myassessments",
						permission: "page_create_from_template",
						icon: "fa-book",
					},
					{
						name: "Assessments",
						path: "/assessments",
						permission: ["page_config_assessments", "page_assign_assessments"],
						icon: "fa-book",
					},
					{
						name: "Templates",
						path: "/templates",
						permission: ["page_config_template", "page_create_template"],
						icon: "fa-book-open",
					},
					// {
					// 	name: "Items",
					// 	path: "/items",
					// 	permission: "page_config_items",
					// 	icon: "fa-book"
					// },
					{
						name: "Rubrics",
						path: "/rubrics",
						permission: "page_config_rubrics",
						icon: "fa-tasks",
					},
					{
						name: "Standards",
						path: "/standards",
						permission: "page_config_standards",
						icon: "fa-ruler",
					},
					{
						name: "Essential Skills",
						path: "/essential_skills",
						permission: "page_config_standards",
						icon: "fa-cubes",
						tenant_permission: "essential_skills",
					},
					{
						name: "Assmts Purpose",
						path: "/assessment_purpose",
						permission: "page_config_standards",
						icon: "fa-cubes",
						tenant_permission: "assessment_purpose",
					},
				],
			},
		};
	},
	created() {
		var indexes = [];
		for (const index in this.groups["Setup/Configuration"]) {
			if (this.groups["Setup/Configuration"][index].tenant_permission) {
				let perm = this.groups["Setup/Configuration"][index].tenant_permission;
				if (this.user.client[perm] != true) {
					indexes.push(index);
					// temp_groups["Setup/Configuration"] = temp_groups["Setup/Configuration"].filter(function(el) { return el.tenant_permission != perm; });
				}
			}
		}
		for (var index = indexes.length - 1; index >= 0; index--) {
			this.groups["Setup/Configuration"].splice(indexes[index], 1);
		}
	},
	mounted() {},
	beforeDestroy() {},
	destroyed() {},
	computed: {},
	watch: {},
	methods: {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/global/ConfigSidenav.vue